import { Navigate, type RouteObject } from 'react-router';
import { HasPermission } from '@/components/Permission/HasPermission';
import Unauthorized from '@/components/Unauthorized';
import PageNotFound from '../../../pages/PageNotFound';
import CompanyProfile from '../../../pages/Settings/CompanyProfile';
import NotificationPreferences from '../../../pages/Settings/NotificationPreferences';
import Password from '../../../pages/Settings/Password';
import Profile from '../../../pages/Settings/Profile';

export default function SettingsRoute() {
  return [
    {
      index: true,
      element: <Navigate replace to={'profile'} />,
    },
    {
      path: 'profile',
      element: <Profile />,
    },
    {
      path: 'password',
      element: <Password />,
    },
    {
      path: 'notifications',
      element: <NotificationPreferences />,
    },
    {
      path: 'company-profile',
      element: (
        <HasPermission of='READ_COMPANY_PROFILE' fallback={<Unauthorized />}>
          <CompanyProfile />
        </HasPermission>
      ),
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ] as RouteObject[];
}
